import axios from "axios";

import ENV from "../../../util/env-config";

class Service {
  static sendAnswer(requestData) {
    return axios.post(ENV.customComBase + "/online_checkin/answer", requestData);
  }

  static uploadImages(requestData) {
    return axios.post(ENV.customComBase + "/communication/upload_attachment", requestData);
  }

  static isAcsesAvailable(requestData) {
    return axios.post(ENV.customComBase + "/online_checkin/is_acses_available", requestData);
  }
}

export default Service;
